/**
 * Contract list filter hook
 */
import { useCallback, useState } from 'react'

export type ContractListFilterState = {
  excludeSettled: boolean
  fromDate?: Date
  toDate?: Date
  filterType: PeriodFilterType
}

export type PeriodFilterType = 'THIS_MONTH' | 'NEXT_MONTH' | 'CUSTOM' | 'ALL'

type Result = {
  filter: ContractListFilterState
  updateFilter: (updates: Partial<ContractListFilterState>) => void
}

export function useContractListFilter(): Result {
  const [filter, setFilter] = useState<ContractListFilterState>({
    excludeSettled: true,
    fromDate: undefined,
    toDate: undefined,
    filterType: 'ALL',
  })

  const updateFilter = useCallback(
    (updates: Partial<ContractListFilterState>) => {
      setFilter((prev) => ({ ...prev, ...updates }))
    },
    [],
  )

  return {
    filter,
    updateFilter,
  }
}
